import React from "react";
import styles from "./assign.module.scss";

const UnSectionBlock = ({ unSectionedQuestions, unSectionRefs, renderQuestion, dragOverTarget, dragItemRef, onDragStart, onDragOver, onDrop, sections }) => {
  const isDraggingFromUnsectioned = dragItemRef?.current?.fromSectionIndex === null;
  return (
    <div
      className={`col-12 ${styles.unsectionedContainer}`}
      onDragOver={(e) => onDragOver(e, null, unSectionedQuestions.length)}
      onDrop={() => onDrop(null, unSectionedQuestions.length)}
    >
      {unSectionedQuestions.map((value, i) => (
        <div
          key={value.tempId}
          draggable
          onDragStart={() => onDragStart(null, i, value.tempId)}
          onDragOver={(e) => onDragOver(e, null, i)}
          onDrop={() => onDrop(null, i)}
          ref={(el) => (unSectionRefs.current[i] = el)}
        >
          {dragOverTarget.sectionIndex === null && dragOverTarget.questionIndex === i && !isDraggingFromUnsectioned && (
            <div className={styles.drop_placeholder}>Drop Individual Question here...</div>
          )}

          {renderQuestion(value, i === unSectionedQuestions.length - 1, i, null, false)}
        </div>
      ))}
      {sections?.length > 0 && unSectionedQuestions.length === 0 && <div className={styles.emptyDropZone}>Drop Individual Question here...</div>}

      {dragOverTarget.sectionIndex === null && dragOverTarget.questionIndex === unSectionedQuestions.length && !isDraggingFromUnsectioned && (
        <div
          className={styles.drop_placeholder}
          onDragOver={(e) => onDragOver(e, null, unSectionedQuestions.length)}
          onDrop={() => onDrop(null, unSectionedQuestions.length)}
        >
          Drop Individual Question here...
        </div>
      )}
    </div>
  );
};

export default UnSectionBlock;
